import { Plus } from '@styled-icons/feather';
import { getLastChildPath } from '@udecode/plate-core';
import classNames from 'classnames';
import { memo } from 'react';
import { Path } from 'slate';
import { addAccordionItem } from '../../../nodes/accordion';
import { useTPlateEditorRef } from '../../../plate';
import { ELEMENT_ACCORDION_ITEM } from '../../../pluginKeys';
import { getSelectedElementEntry } from '../../../plugins/elementSelection';
import toolbarStyles from '../SideToolbar.module.css';

function AccordionAddItem() {
  const editor = useTPlateEditorRef();

  const handleAddAccordionItemClick = () => {
    const entry = getSelectedElementEntry(editor);

    if (!entry) return;

    const [element, path] = entry;

    const insertAfter = element.type === ELEMENT_ACCORDION_ITEM ? path : getLastChildPath(entry);

    addAccordionItem(editor, Path.next(insertAfter));
  };

  return (
    <div className={toolbarStyles.section}>
      <span className={toolbarStyles.label}>Accordion Item</span>
      <button
        type="button"
        className={classNames(toolbarStyles.button)}
        onClick={handleAddAccordionItemClick}
      >
        <Plus size={16} className="mr-1" />
        <span>Add Accordion Item</span>
      </button>
    </div>
  );
}

export default memo(AccordionAddItem);
